// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__31h23","content":"Consent_content__1Pv3-","footer":"Consent_footer__2YnkF"};